"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const Tooltip_1 = __importDefault(require("@web/common/Tooltip"));
(() => {
    const dislikeButtons = Array.from(document.querySelectorAll('.dislike-subscription-price-offer'));
    const favoriteListingList = document.querySelector('.favorite-listing-item-offers-list');
    const headerFavoritePriceOffersLink = document.getElementById('header-favorite-price-offers-link');
    const headerCntElement = headerFavoritePriceOffersLink === null || headerFavoritePriceOffersLink === void 0 ? void 0 : headerFavoritePriceOffersLink.querySelector('.items-count');
    dislikeButtons.forEach((dislikeButton) => {
        dislikeButton.addEventListener('click', (ev) => {
            ev.preventDefault();
            const url = SymfonyRouter_1.default.getRoute('api.subscription_offer.remove_favorite', {
                subscriptionCarOfferId: dislikeButton.dataset.subscriptionOfferId,
            });
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.onloadstart = () => {
                var _a;
                const listingCarItem = (_a = dislikeButton.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
                if (listingCarItem) {
                    listingCarItem.style.opacity = '0.5';
                }
            };
            xhr.onload = () => {
                var _a;
                if (xhr.status === 200) {
                    const listingCarItem = (_a = dislikeButton.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
                    if (listingCarItem && headerCntElement && favoriteListingList) {
                        listingCarItem.remove();
                        headerCntElement.innerText = String(Number(headerCntElement.innerText) - 1);
                        const listingCarItemCount = favoriteListingList.querySelectorAll('.listing-item-offer-box').length;
                        if (listingCarItemCount === 0) {
                            favoriteListingList.remove();
                            if (headerFavoritePriceOffersLink) {
                                (() => new Tooltip_1.default(headerFavoritePriceOffersLink))();
                            }
                        }
                    }
                }
            };
            xhr.send();
        });
    });
})();
